/* Shared visual treatment for a search hit. Used by the notes-list cells
 * (`HighlightedText`, `SearchMatchSnippet`, which render real <mark>
 * elements) and by the note body's ProseMirror decoration, which cannot
 * render an element and instead applies these classes to an inline
 * decoration span. Keeping one constant is what makes a hit look the
 * same in the list and in the document. */
export const SEARCH_HIGHLIGHT_CLASS =
  'px-0.5 text-gray-900 bg-yellow-100 rounded-sm'
